/**
 * Core user type used across the system
 */
export interface User {
  id: string;
  email: string;
  name?: string;
  title?: string;
  lastLoginAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export type UserSearchResult = Pick<User, 'id' | 'email' | 'name' | 'title'>;

/**
 * Gets the initials of a user based on their name or email
 * @param user The user object
 * @returns The user's initials (up to 2 characters)
 */
export function getInitials(name?: string, email?: string): string {
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    } else if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
  }
  return email ? email[0].toUpperCase() : '?';
}

export function getUserInitials(user: User): string {
  return getInitials(user.name, user.email);
}

/**
 * Special system user for backend-initiated actions (e.g., workflow automation)
 */
export const SYSTEM_USER: User = {
  id: 'usr_system',
  email: 'system@promo.kareotest.com',
  name: 'System',
  createdAt: new Date(0),
  updatedAt: new Date(0),
};
